<template>
	<div class="login-page">
		<div class="logo-box">
			<img src="../../assets/images/logo.png" height="30" @click="goHome();" />
		</div>
		<div class="login-box">
			<div class="img-box">
				<img src="../../assets/images/login-img.png" />
			</div>
			<div class="form-box">
				<div class="title">欢迎登录</div>
				<el-form :model="formData" :rules="rules" ref="ruleForm">
					<el-form-item label="" prop="username">
						<el-input v-model="formData.username" placeholder="请输入用户名" @keyup.enter.native="onSubmit">
							<i slot="prefix" class="el-input__icon el-icon-user"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="" prop="password">
						<el-input v-model="formData.password" type="password" placeholder="请输入密码" @keyup.enter.native="onSubmit">
							<i slot="prefix" class="el-input__icon el-icon-lock"></i>
						</el-input>
					</el-form-item>
					<el-button type="primary" :loading="loading" @click="onSubmit">登录</el-button>
				</el-form>
				<div class="agreement">
					<el-checkbox v-model="agreementCheck">
						我已阅读并同意
						<a href="https://syjk-oss.sypmyoulecai.com/syjk-purchase/html/user-agree.html" target="view_window">《用户协议》</a>
					</el-checkbox>
				</div>
				<!-- <div class="register">免费注册</div> -->
			</div>
		</div>
		<vFooter></vFooter>
	</div>
</template>

<script>
	import vFooter from '@/layout/vFooter.vue';
	import {
		getCartList
	} from '@/api/goods.js';

	export default {
		components: {
			vFooter
		},
		data() {
			return {
				loading: false,
				formData: {
					username: '',
					password: ''
				},
				rules: {
					username: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 20,
							message: '用户名不正确',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码不正确',
							trigger: 'blur'
						}
					]
				},
				agreementCheck: false
			};
		},
		methods: {
			goHome() {
				this.$router.replace('/home');
			},
			
			onSubmit() {
				if (!this.agreementCheck) {
					this.$message('请阅读并同意《会员协议》')
					return false;
				}

				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.loading = true;
						this.$store.dispatch("login", this.formData).then(result => {
							this.loading = false;
							if (result && result.code == 0) {
								getCartList();
								
								if(result?.data?.enterpriseType == 'SALESMAN'){
									this.$router.push('/chooseGroup');
								} else {
									if (this.$route.query && this.$route.query.redirect) {
										this.$router.replace(this.$route.query.redirect);
									}
									else {
										this.$router.replace('/home');
									}
								}
								
							} else {
								this.$message.error(result.msg);
							}
						});
					} else {
						return false;
					}
				});
			}
		},
	};
</script>

<style lang="scss" rel="stylesheet/scss">
	.login-page {
		width: 100vw;
		min-width: 1240px;
		height: 100vh;
		background-color: #FFFFFF;

		.logo-box {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding-left: 20vw;
			height: 100px;
			font-size: 20px;
			font-weight: bold;
			color: #262728;
			cursor: pointer;
		}

		.login-box {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			min-width: 1240px;
			height: calc(100vh - 260px);
			min-height: 500px;
			background-color: #FAF1DF;

			.img-box {
				width: 462px;
				height: 305px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.form-box {
				margin-left: 260px;
				width: 320px;
				height: 346px;
				background: #FFFFFF;
				box-shadow: 0px 30px 60px 0px rgba(0, 0, 0, 0.06);
				border-radius: 20px;

				.title {
					margin-top: 24px;
					text-align: center;
					font-weight: bold;
					font-size: 20px;
					color: #262728;
				}

				.el-form {
					padding: 18px 24px 0;
					
					.el-input--prefix .el-input__inner {
						padding-left: 40px;
					}
					
					.el-input {
						.el-input__inner {
							width: 270px;
							height: 48px;
							line-height: 48px;
							border: 1px solid #EDEFF2;
							border-radius: 10px;
							font-size: 14px;
							color: #262728;
						}

						.el-input__inner::-webkit-input-placeholder {
							color: #909399;
						}
						
						.el-input__prefix {
							left: 0;
						}
						
						.el-input__icon {
							width: 44px;
							height: 45px;
							line-height: 45px;
							font-size: 18px;
							color: #C2C6CD;
						}
					}

					.el-form-item__error {
						padding-left: 6px;
					}

					.el-button {
						width: 100%;
						height: 48px;
						border-radius: 10px;
						font-size: 18px;
						color: #262728;
					}
				}

				.agreement {
					margin-top: 14px;
					padding: 0 35px 0 24px;
					width: 100%;
					font-size: 14px;
					color: #606366 !important;

					.el-checkbox {
						display: flex;
						justify-content: flex-start;
						align-items: flex-start;
					}

					.el-checkbox__input.is-checked .el-checkbox__inner {
						border-color: #FECE36 !important;
					}

					.el-checkbox__input.is-focus .el-checkbox__inner {
						border-color: #C0C4CC;
					}

					.el-checkbox__inner {
						margin-top: 2px;
						width: 16px;
						height: 16px;
						border-radius: 100%;
					}
					
					.el-checkbox__inner::after {
						top: 2px;
						left: 5px;
					}

					.el-checkbox__label {
						white-space: pre-wrap;
					}

					.el-checkbox__input.is-checked+.el-checkbox__label {
						color: #606366 !important;
					}
				}

				.register {
					display: flex;
					justify-content: center;
					align-items: center;
					margin-top: 20px;
					width: 100%;
					height: 50px;
					border-top: 1px dashed #EDEFF2;
					font-size: 14px;
					text-decoration: underline;
					color: #909399;
				}
			}
		}
	}
</style>
